import React from 'react';

export default (props) => (
  <svg {...props} width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M15 0C6.75 0 0 6.75 0 15C0 23.25 6.75 30 15 30C23.25 30 30 23.25 30 15C30 6.75 23.25 0 15 0ZM15 27.1875C8.25 27.1875 2.8125 21.75 2.8125 15C2.8125 8.25 8.25 2.8125 15 2.8125C21.75 2.8125 27.1875 8.25 27.1875 15C27.1875 21.75 21.75 27.1875 15 27.1875Z" fill="currentColor" />
    <path d="M14.9996 19.5C14.0621 19.5 13.3121 20.25 13.3121 21C13.3121 21.75 14.0621 22.5 14.9996 22.5C15.9371 22.5 16.4996 21.75 16.4996 21C16.4996 20.25 15.7496 19.5 14.9996 19.5Z" fill="currentColor" />
    <path d="M16.4999 7.125H13.6874V18H16.4999V7.125Z" fill="currentColor" />
  </svg>
);
